module.exports = __webpack_public_path__ + "img/visa-img2@2x.fb3feb7e.png";